/**
 * Insignias federativas locales de las selecciones del Mundial 2026.
 *
 * Las copias se distribuyen dentro de public/assets para que una partida no
 * dependa de peticiones externas. Fuente del lote: wc26-assets, catálogo
 * público de recursos estáticos con insignias de selecciones.
 */
export const COUNTRY_FEDERATION_BADGES: Readonly<Record<string, string>> = {
  México: '/assets/federations/mexico-national-team.png',
  Sudáfrica: '/assets/federations/south-africa-national-team.png',
  'República de Corea': '/assets/federations/south-korea-national-team.png',
  Chequia: '/assets/federations/czechia-national-team.png',
  Canadá: '/assets/federations/canada-national-team.png',
  Italia: '/assets/federations/italy-national-team.png',
  Catar: '/assets/federations/qatar-national-team.png',
  Suiza: '/assets/federations/switzerland-national-team.png',
  Brasil: '/assets/federations/brazil-national-team.png',
  Haití: '/assets/federations/haiti-national-team.png',
  Marruecos: '/assets/federations/morocco-national-team.png',
  Escocia: '/assets/federations/scotland-national-team.png',
  'Estados Unidos': '/assets/federations/usmnt-national-team.png',
  Paraguay: '/assets/federations/paraguay-national-team.png',
  Australia: '/assets/federations/australia-national-team.png',
  Turquía: '/assets/federations/turkey-national-team.png',
  Alemania: '/assets/federations/germany-national-team.png',
  Curazao: '/assets/federations/curacao-national-team.png',
  'Costa de Marfil': '/assets/federations/cote-divoire-national-team.png',
  Ecuador: '/assets/federations/ecuador-national-team.png',
  'Países Bajos': '/assets/federations/netherlands-national-team.png',
  Japón: '/assets/federations/japan-national-team.png',
  Túnez: '/assets/federations/tunisia-national-team.png',
  Suecia: '/assets/federations/sweden-national-team.png',
  Bélgica: '/assets/federations/belgium-national-team.png',
  Egipto: '/assets/federations/egypt-national-team.png',
  Irán: '/assets/federations/iran-national-team.png',
  'Nueva Zelanda': '/assets/federations/new-zealand-national-team.png',
  España: '/assets/federations/spain-national-team.png',
  'Cabo Verde': '/assets/federations/cape-verde-national-team.png',
  'Arabia Saudí': '/assets/federations/saudi-arabia-national-team.png',
  Uruguay: '/assets/federations/uruguay-national-team.png',
  Francia: '/assets/federations/france-national-team.png',
  Senegal: '/assets/federations/senegal-national-team.png',
  Irak: '/assets/federations/iraq-national-team.png',
  Noruega: '/assets/federations/norway-national-team.png',
  Argentina: '/assets/federations/argentina-national-team.png',
  Argelia: '/assets/federations/algeria-national-team.png',
  Austria: '/assets/federations/austria-national-team.png',
  Jordania: '/assets/federations/jordan-national-team.png',
  Portugal: '/assets/federations/portugal-national-team.png',
  Colombia: '/assets/federations/colombia-national-team.png',
  Uzbekistán: '/assets/federations/uzbekistan-national-team.png',
  'República Democrática del Congo': '/assets/federations/dr-congo-national-team.png',
  Inglaterra: '/assets/federations/england-national-team.png',
  Croacia: '/assets/federations/croatia-national-team.png',
  Ghana: '/assets/federations/ghana-national-team.png',
  Panamá: '/assets/federations/panama-national-team.png',
}
